module.exports = __webpack_public_path__ + "static/media/1ton-variant-2.43d3377c.jpg";